import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeavesService {
  public REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;
  
  constructor(private http:HttpClient) { }

  public getLeaves(filterParams:any={}):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/leaves`,{params:filterParams,observe:'response'});
  }

  public createLeave(data:any):Observable<any>{
    return this.http.post(`${this.REST_API_SERVER}/leaves/create`,data);
  }

  public getAvailableLeaves(data:any):Observable<any>{
    return this.http.post(`${this.REST_API_SERVER}/leaves/availabelleaves`,data);
  }

  public getUpdateLeave(data:any):Observable<any>{
    return this.http.post(`${this.REST_API_SERVER}/leaves/updateleavesdata`,data);
  }

  public getViewLeaveDetails(filterParams:any={}):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/leaves/leaveapplieddetails`,{params:filterParams,observe:'response'});
  }
}